import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'et-atoms-page-tabs',
  templateUrl: './page-tabs.component.html',
  styleUrls: ['./page-tabs.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PageTabsComponent {}
